//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Mobile',
}
